/* ADAYA — theme behaviour.
   Vanilla, no dependencies. Nothing here is load-bearing: with JavaScript off the
   store still reads, adds to cart, and checks out through native form posts. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- reveal */
  /* One authored moment: sections rise once, the strand draws down behind them. */
  function observe(nodes, cls, ratio) {
    if (!('IntersectionObserver' in window) || reduce) {
      nodes.forEach(function (n) {
        n.classList.add(cls);
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add(cls);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: ratio || 0.08, rootMargin: '0px 0px -6% 0px' }
    );
    nodes.forEach(function (n) {
      io.observe(n);
    });
  }

  function boot() {
    var reveals = [].slice.call(document.querySelectorAll('[data-reveal]'));
    reveals.forEach(function (n, i) {
      var group = n.closest('[data-reveal-group]');
      if (group) {
        var kids = [].slice.call(group.querySelectorAll('[data-reveal]'));
        n.style.setProperty('--delay', Math.min(kids.indexOf(n), 8) * 0.06 + 's');
      }
    });
    observe(reveals, 'is-in');
    observe([].slice.call(document.querySelectorAll('.strand')), 'is-in', 0.01);
  }

  /* ----------------------------------------------------------- story scroll */
  /* Scroll drives the story: progress across the tall container picks the
     active element, fills the rail, and lights the beads star to heart. */
  function bindStoryScroll() {
    var wrap = document.querySelector('[data-sstory]');
    if (!wrap || reduce) return;
    var section = wrap.closest('.sstory');
    var steps = [].slice.call(wrap.querySelectorAll('[data-sstep]'));
    var dots = [].slice.call(wrap.querySelectorAll('[data-sdot]'));
    var fill = wrap.querySelector('[data-sfill]');
    if (!steps.length) return;
    var active = 0;
    var ticking = false;

    function paint() {
      ticking = false;
      var rect = wrap.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = rect.height - vh;
      if (total <= 0) return;
      var p = Math.min(1, Math.max(0, -rect.top / total));
      var idx = Math.min(steps.length - 1, Math.floor(p * steps.length));
      if (idx !== active) {
        steps[active].classList.remove('is-act');
        steps[idx].classList.add('is-act');
        active = idx;
      }
      dots.forEach(function (d, i) {
        d.classList.toggle('is-done', i <= idx && p > 0);
      });
      if (fill) fill.style.transform = 'scaleY(' + p.toFixed(4) + ')';
      if (section) section.classList.toggle('is-done', p > 0.05);
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(paint);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    paint();
  }

  /* ------------------------------------------------------------------ menu */
  var focusables =
    'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function trap(panel) {
    var nodes = [].slice.call(panel.querySelectorAll(focusables)).filter(function (n) {
      return n.offsetParent !== null;
    });
    if (!nodes.length) return function () {};
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    function onKey(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    panel.addEventListener('keydown', onKey);
    first.focus();
    return function () {
      panel.removeEventListener('keydown', onKey);
    };
  }

  function overlay(el, openers, closers) {
    if (!el) return null;
    var release = null;
    var opener = null;
    function open(from) {
      opener = from || document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      release = trap(el);
    }
    function close() {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (release) release();
      release = null;
      if (opener && opener.focus) opener.focus();
    }
    openers.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        open(b);
      });
    });
    closers.forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-open')) close();
    });
    return { open: open, close: close };
  }

  function q(sel, root) {
    return [].slice.call((root || document).querySelectorAll(sel));
  }

  /* ------------------------------------------------------------------ cart */
  var drawer = null;

  function money(cents) {
    var f = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: f
      }).format(cents / 100);
    } catch (err) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function refreshCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-contents]');
        var here = document.querySelector('[data-cart-contents]');
        if (fresh && here) here.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('[data-cart-total-count]');
        q('[data-cart-count]').forEach(function (n) {
          var v = count ? count.getAttribute('data-cart-total-count') : '0';
          n.textContent = v;
          n.hidden = v === '0';
        });
        bindCart();
      });
  }

  function bindCart() {
    q('[data-cart-remove]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var key = b.getAttribute('data-cart-remove');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(refreshCart);
      });
    });
    /* the drawer upsell: one tap completes the pair */
    q('[data-upsell-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = parseInt(b.getAttribute('data-upsell-add'), 10);
        if (!id) return;
        var label = b.innerHTML;
        b.setAttribute('aria-busy', 'true');
        b.textContent = b.getAttribute('data-adding') || 'Adding';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('upsell add failed');
            return refreshCart();
          })
          .catch(function () {
            b.removeAttribute('aria-busy');
            b.innerHTML = label;
          });
      });
    });
  }

  function bindAddToCart() {
    q('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; /* let it post natively */
        e.preventDefault();
        var btn = form.querySelector('[data-add]');
        var label = btn ? btn.textContent : '';
        if (btn) {
          btn.setAttribute('aria-busy', 'true');
          btn.textContent = btn.getAttribute('data-adding') || 'Adding';
        }
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            return refreshCart();
          })
          .then(function () {
            if (drawer) drawer.open(btn);
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (btn) {
              btn.removeAttribute('aria-busy');
              btn.textContent = label;
            }
          });
      });
    });
  }

  /* -------------------------------------------------------------- quantity */
  function bindQty() {
    q('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      q('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === 'down' ? -1 : 1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* --------------------------------------------------------------- gallery */
  function bindGallery() {
    var g = document.querySelector('[data-gallery]');
    if (!g) return;
    var main = g.querySelector('[data-gallery-main] img');
    if (!main) return;
    q('[data-gallery-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        var alt = t.getAttribute('data-alt') || '';
        if (src) {
          main.src = src;
          main.srcset = t.getAttribute('data-srcset') || '';
          main.alt = alt;
        }
        q('[data-gallery-thumb]', g).forEach(function (o) {
          o.setAttribute('aria-current', o === t ? 'true' : 'false');
        });
      });
    });
  }

  /* -------------------------------------------------------------- variants */
  function bindVariants() {
    var data = document.querySelector('[data-variants]');
    var form = document.querySelector('form[action$="/cart/add"]');
    if (!data || !form) return;
    var variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (err) {
      return;
    }
    var idField = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('.product__price');
    var addBtn = form.querySelector('[data-add]');
    var radios = q('input[type="radio"][data-option-position]', form);
    if (!radios.length || !idField) return;

    function chosen() {
      var out = [];
      radios.forEach(function (r) {
        if (r.checked) out[parseInt(r.getAttribute('data-option-position'), 10) - 1] = r.value;
      });
      return out;
    }

    function update() {
      var picked = chosen();
      var match = null;
      variants.forEach(function (v) {
        if (match) return;
        var ok = true;
        picked.forEach(function (val, i) {
          if (v.options[i] !== val) ok = false;
        });
        if (ok) match = v;
      });
      if (!match) return;
      idField.value = match.id;
      if (priceEl && match.price != null) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceEl.innerHTML = '';
          var was = document.createElement('del');
          was.textContent = money(match.compare_at_price);
          priceEl.appendChild(was);
          priceEl.appendChild(document.createTextNode(' ' + money(match.price)));
        } else {
          priceEl.textContent = money(match.price);
        }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.setAttribute('aria-disabled', match.available ? 'false' : 'true');
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', update);
    });
  }

  /* ---------------------------------------------------------------- bundle */
  function bindBundle() {
    q('[data-bundle-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var ids;
        try {
          ids = JSON.parse(btn.getAttribute('data-bundle-variants'));
        } catch (err) {
          return;
        }
        var label = btn.innerHTML;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = btn.getAttribute('data-adding') || 'Adding';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: ids.map(function (id) {
              return { id: id, quantity: 1 };
            })
          })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('bundle add failed');
            return refreshCart();
          })
          .then(function () {
            if (drawer) drawer.open(btn);
          })
          .catch(function () {})
          .finally(function () {
            btn.removeAttribute('aria-busy');
            btn.innerHTML = label;
          });
      });
    });
  }

  /* ------------------------------------------------------------------ init */
  document.addEventListener('DOMContentLoaded', function () {
    boot();
    bindStoryScroll();
    bindQty();
    bindGallery();
    bindVariants();
    bindAddToCart();
    bindBundle();
    bindCart();

    overlay(
      document.querySelector('[data-menu]'),
      q('[data-menu-open]'),
      q('[data-menu-close]')
    );

    drawer = overlay(
      document.querySelector('[data-drawer]'),
      q('[data-drawer-open]'),
      q('[data-drawer-close]')
    );

    var veil = document.querySelector('[data-drawer] .drawer__veil');
    if (veil && drawer) veil.addEventListener('click', drawer.close);
  });
})();
